// extracted by mini-css-extract-plugin
module.exports = {"root":"_2Uaru","wrapper":"_2iAfx","spinner":"_3uU_E"};